/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M18 11L15 8M18 11L15 14M18 11H10.6667C9.11217 11 8.33488 11 7.73209 11.2811C7.09291 11.5792 6.57917 12.0929 6.2811 12.7321C6 13.3349 6 14.1122 6 15.6667V15.6667V16.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M18 11L15 8M18 11L15 14M18 11H10.6667C8.08937 11 6 13.0894 6 15.6667V15.6667V16.0001M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM15.5303 7.46959C15.2374 7.1767 14.7626 7.1767 14.4697 7.46959C14.1768 7.76248 14.1768 8.23736 14.4697 8.53025L16.1893 10.2499H10.6667H10.6371H10.637C9.88493 10.2499 9.27828 10.2499 8.78586 10.2872C8.27917 10.3256 7.8327 10.4066 7.41511 10.6013C6.61613 10.9739 5.97397 11.6161 5.60138 12.415C5.40664 12.8326 5.32565 13.2791 5.28728 13.7858C5.24999 14.2782 5.24999 14.8849 5.25 15.637V15.6667V16C5.25 16.4142 5.58579 16.75 6 16.75C6.41421 16.75 6.75 16.4142 6.75 16V15.6667C6.75 14.8779 6.7505 14.3282 6.783 13.8991C6.8149 13.4778 6.87446 13.2342 6.96083 13.049C7.18438 12.5696 7.56968 12.1843 8.04907 11.9607C8.23427 11.8744 8.47785 11.8148 8.89913 11.7829C9.32824 11.7504 9.87803 11.7499 10.6667 11.7499H16.1893L14.4697 13.4696C14.1768 13.7625 14.1768 14.2374 14.4697 14.5302C14.7626 14.8231 15.2374 14.8231 15.5303 14.5302L18.5303 11.5302C18.671 11.3896 18.75 11.1988 18.75 10.9999C18.75 10.801 18.671 10.6102 18.5303 10.4696L15.5303 7.46959Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 14.5L2 15V15C2 16.8613 2 17.7919 2.24472 18.5451C2.73931 20.0673 3.93273 21.2607 5.45491 21.7553C6.20808 22 7.13872 22 9 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2L9 2C7.13872 2 6.20808 2 5.45491 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9V9L2 9.5M18 11L15 8M18 11L15 14M18 11H10.6667C8.08937 11 6 13.0894 6 15.6667V15.6667V16.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M18 11L15 8M18 11L15 14M18 11H10.6667C8.08937 11 6 13.0894 6 15.6667V15.6667V16.0001M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.4697 7.46967C14.7626 7.17678 15.2374 7.17678 15.5303 7.46967L18.5303 10.4697C18.671 10.6103 18.75 10.8011 18.75 11C18.75 11.1989 18.671 11.3897 18.5303 11.5303L15.5303 14.5303C15.2374 14.8232 14.7626 14.8232 14.4697 14.5303C14.1768 14.2374 14.1768 13.7626 14.4697 13.4697L16.1893 11.75H10.6667C9.87803 11.75 9.32824 11.7505 8.89913 11.783C8.47785 11.8149 8.23427 11.8745 8.04907 11.9608C7.56968 12.1844 7.18438 12.5697 6.96083 13.0491C6.87446 13.2343 6.8149 13.4778 6.783 13.8991C6.7505 14.3282 6.75 14.878 6.75 15.6667V16.0001C6.75 16.4143 6.41421 16.7501 6 16.7501C5.58579 16.7501 5.25 16.4143 5.25 16.0001V15.6667L5.25 15.6371C5.24999 14.885 5.24999 14.2783 5.28728 13.7859C5.32565 13.2792 5.40664 12.8327 5.60138 12.4151C5.97397 11.6161 6.61613 10.974 7.41511 10.6014C7.8327 10.4066 8.27917 10.3257 8.78587 10.2873C9.27829 10.25 9.88496 10.25 10.6371 10.25H10.6667H16.1893L14.4697 8.53033C14.1768 8.23744 14.1768 7.76256 14.4697 7.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
